// RHF v5 returns an array for a checkbox group, but a single checkbox yields its raw value or false.
export const getSelectedReasonIds = value =>
  (Array.isArray(value) ? value : [value]).filter(Boolean).map(Number);
